import { render } from "./ProfessionalRoute.vue?vue&type=template&id=122207a1&ts=true"
import script from "./ProfessionalRoute.vue?vue&type=script&lang=ts"
export * from "./ProfessionalRoute.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__